import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { startLoadingCatalogCiiuByParentLocal, startLoadingCatalogCiiusByLevel1 } from '../actions/catalogCiiuActions';
import { startLoadingCatalogPhaseByParentLocal, startLoadingCatalogPhasesByLevel1 } from '../actions/catalogPhaseActions';
import { startLoadingCatalogSectionByParentLocal, startLoadingCatalogSectionsByLevel1 } from '../actions/catalogSectionActions';
import { hydrateMultilevelSelectFields } from '../helpers/helperCatalogs';

const applyMultilevelPatch = (values, setValues, dispatch, catalogList, group) => {
  const patch = hydrateMultilevelSelectFields({
    values,
    catalogList,
    prefix: group.prefix,
    idField: group.idField,
    levelsField: group.levelsField,
    maxLevels: group.maxLevels
  });
  if (!patch[`${group.prefix}_level1`]) {
    return;
  }

  const sameLevel = values?.[`${group.prefix}_level1`]?.id === patch[`${group.prefix}_level1`].id;
  const sameId = String(values?.[group.idField] || '') === String(patch[group.idField] || '');
  const sameCodes = String(values?.[group.levelsField] || '') === String(patch[group.levelsField] || '');
  if (sameLevel && sameId && sameCodes) {
    return;
  }

  setValues((prev) => ({ ...(prev || {}), ...patch }));
  if (typeof group.loadLevel1 === 'function') {
    dispatch(group.loadLevel1());
  }
  for (let level = 1; level < group.maxLevels; level++) {
    const current = patch[`${group.prefix}_level${level}`];
    if (current?.id && typeof group.loadChild === 'function') {
      dispatch(group.loadChild(current.id, level + 1));
    }
  }
};

const useHydrateMultilevelSelects = ({
  values,
  setValues,
  listFullCatalogCiius,
  listFullCatalogSections,
  listFullCatalogPhases
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    applyMultilevelPatch(values, setValues, dispatch, listFullCatalogCiius, {
      prefix: 'catalogciiu',
      idField: 'catalogciius_id',
      levelsField: 'catalogciiu_levels',
      maxLevels: 6,
      loadLevel1: () => startLoadingCatalogCiiusByLevel1(1),
      loadChild: (id, nextLevel) => startLoadingCatalogCiiuByParentLocal(id, nextLevel)
    });
  }, [
    dispatch,
    listFullCatalogCiius,
    setValues,
    values?.catalogciiu_level1,
    values?.catalogciiu_levels,
    values?.catalogciius_id
  ]);

  useEffect(() => {
    applyMultilevelPatch(values, setValues, dispatch, listFullCatalogSections, {
      prefix: 'catalogsection',
      idField: 'catalogsections_id',
      levelsField: 'catalogsection_levels',
      maxLevels: 3,
      loadLevel1: () => startLoadingCatalogSectionsByLevel1(1),
      loadChild: (id, nextLevel) => startLoadingCatalogSectionByParentLocal(id, nextLevel)
    });
  }, [
    dispatch,
    listFullCatalogSections,
    setValues,
    values?.catalogsection_level1,
    values?.catalogsection_levels,
    values?.catalogsections_id
  ]);

  useEffect(() => {
    applyMultilevelPatch(values, setValues, dispatch, listFullCatalogPhases, {
      prefix: 'catalogphase',
      idField: 'catalogphases_id',
      levelsField: 'catalogphase_levels',
      maxLevels: 5,
      loadLevel1: () => startLoadingCatalogPhasesByLevel1(1),
      loadChild: (id, nextLevel) => startLoadingCatalogPhaseByParentLocal(id, nextLevel)
    });
  }, [
    dispatch,
    listFullCatalogPhases,
    setValues,
    values?.catalogphase_level1,
    values?.catalogphase_levels,
    values?.catalogphases_id
  ]);
};

export default useHydrateMultilevelSelects;
